import mapButtonProps from './mapButtonProps';

export default function bodyTextsContainerMapper(componentsData) {
  const { productData, ...componentRest } = componentsData;

  return {
    ...componentRest,
    productData: productData.map(product => mapButtonProps(product)),
  };
}
